import { useAtsProjectsApi } from '@/composables/useApi';
import { HttpStatus } from '@/core/shared/errors/enums/http-status.enum';
import { InternalError } from '@/core/shared/errors/internal.error';
import type { JobCustomSkill } from '@factoryfixinc/ats-interfaces';

export class CustomSkillPersistence {
  public async getProjectCustomSkills(
    employerId: number,
    projectId: number,
  ): Promise<JobCustomSkill[]> {
    const url = `/project/${projectId}/employer/${employerId}/custom-skill`;
    const { data, error, statusCode } = await useAtsProjectsApi(url).get().json<JobCustomSkill[]>();

    if (statusCode.value === HttpStatus.NOT_FOUND || statusCode.value === HttpStatus.FORBIDDEN) {
      return [];
    }

    if (error.value) {
      throw new InternalError('Could not get project custom skills', {
        error: error.value,
        status: statusCode.value,
        data: { employerId, projectId },
      });
    }

    return data.value ?? [];
  }

  public async replaceProjectCustomSkills(
    employerId: number,
    projectId: number,
    customSkills: JobCustomSkill[],
  ): Promise<JobCustomSkill[]> {
    const url = `/project/${projectId}/employer/${employerId}/custom-skill`;
    const { data, error, statusCode } = await useAtsProjectsApi(url)
      .put(JSON.stringify(customSkills))
      .json<JobCustomSkill[]>();

    if (error.value) {
      throw new InternalError('Could not replace project custom skills', {
        error: error.value,
        status: statusCode.value,
        data: { employerId, projectId, customSkills },
      });
    }

    return data.value ?? [];
  }
}
